import script from "./InquiryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InquiryDetail.vue?vue&type=script&setup=true&lang=js"

import "./InquiryDetail.vue?vue&type=style&index=0&id=ebe6490a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebe6490a"]])

export default __exports__